import {DealerBike, DealerBikeStatus, Document, LoanStatus, ProbabilityOfSale, UsageType} from '@/types/dynamodb-types'
export {DealerBike, DealerBikeStatus, Document, LoanStatus, ProbabilityOfSale, UsageType}

export const DealerBikeStatusPortal = {
  Candidate: 'CANDIDATE',
  Available: DealerBikeStatus.Available,
  Unavailable: DealerBikeStatus.Unavailable,
  HandedOver: 'HANDED_OVER',
  Expired: 'EXPIRED',
  Retired: DealerBikeStatus.Retired,
}

export enum DealerBikeActions {
  Available = 'AVAILABLE',
  Courtesy = 'COURTESY',
  Deactivate = 'DEACTIVATE',
  Detail = 'DETAIL',
  Register = 'REGISTER',
  RemoveBike = 'REMOVE_BIKE',
  Transfer = 'TRANSFER',
  Unavailable = 'UNAVAILABLE',
  Unregister = 'UNREGISTER',
}
